import {chakra} from '@chakra-ui/react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export const SelectIcon = chakra(FontAwesomeIcon, {
  baseStyle: {
    width: `1em`,
    height: `1em`,
    fontSize: `md`,
  },
});
